import { AR, EN } from './assets';

export const languages = [
    { id: "ar-SA", miniTitle: "ع", imageSource: AR, title: "العربية" },
    { id: "en-US", miniTitle: "EN", imageSource: EN, title: "English" }
]

export { default as AppBarLocalizationMenu } from './AppBarLocalizationMenu';
export { default as LocalizationToggle } from './LocalizationToggle';